import { apiSlice } from "../../api-slice";
import { CreateCategory, CreateCategoryRequest } from "./account-category-api-request";
import { AccountCategoryType, CategoryResponse } from "./account-category-api-state";

export const accountCategoryListAPI = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getRoleType: builder.query<AccountCategoryType[], void>({
            query: () => `api/system-lookup/category/ROLE`,
            transformResponse: (response: CategoryResponse) => response.data,
            transformErrorResponse: (response: any) => response,
            providesTags: [{ type: 'AcctRole', id: 'LIST' }]
        }),
        getDepartmentType: builder.query<AccountCategoryType[], void>({
            query: () => `api/system-lookup/category/DEPARTMENT`,
            transformResponse: (response: CategoryResponse) => response.data,
            transformErrorResponse: (response: any) => response,
            providesTags: [{ type: 'AcctDepartment', id: 'LIST' }]
        }),
        getLocationType: builder.query<AccountCategoryType[], void>({
            query: () => `api/system-lookup/category/LOCATION`,
            transformResponse: (response: CategoryResponse) => response.data,
            transformErrorResponse: (response: any) => response,
            providesTags: [{ type: 'AcctLocation', id: 'LIST' }]
        }),

        createCategory: builder.mutation<any, CreateCategoryRequest>({
            query: ({ category, body }) => ({
                url: `/api/system-lookup/category/${category}`,
                method: "POST",
                body,
            }),
            transformErrorResponse: (response: any) => response.data,
            invalidatesTags: (result, error, { category }) => {
                switch (category) {
                    case "ROLE":
                        return [{ type: "AcctRole", id: "LIST" }];
                    case "DEPARTMENT":
                        return [{ type: "AcctDepartment", id: "LIST" }];
                    case "LOCATION":
                        return [{ type: "AcctLocation", id: "LIST" }];
                    default:
                        return [];
                }
            },
        }),
        updateCategory: builder.mutation<any, {categoryId: number, body: CreateCategory}>({
            query: ({ categoryId, body }) => ({
                url: `/api/system-lookup/${categoryId}`,
                method: 'PUT',
                body,
            }),
            transformErrorResponse: (response: any) => response.data,
            invalidatesTags: (result, error, { categoryId }) => [
                { type: "AcctRole", id: "LIST" },
                { type: "AcctRole", id: categoryId },
                { type: "AcctDepartment", id: "LIST" },
                { type: "AcctDepartment", id: categoryId },
                { type: "AcctLocation", id: "LIST" },
                { type: "AcctLocation", id: categoryId },
            ],
        }),
    })
})

export const {
    useGetRoleTypeQuery,
    useGetDepartmentTypeQuery,
    useGetLocationTypeQuery,

    useCreateCategoryMutation,
    useUpdateCategoryMutation,
} = accountCategoryListAPI